import { Style, Fill, Stroke, Circle } from 'ol/style';
import StrokePattern from "ol-ext/style/StrokePattern";
import { IStyleCache, CoreLayerConfig } from '../../Models/MapConfigModels';
import { MultiPoint, Point } from 'ol/geom';
import { Feature } from 'ol';
import { MapStyles } from '../MapStyles';
import VectorLayer from 'ol/layer/Vector';

export class LegalRouteMapStyles {
    // Private variables
    private defaultOverrideLineStyle = new Style({ stroke: new Stroke({ color: 'rgba(255, 78, 50, 1)', width: 3 }), fill: new Fill({ color: 'rgba(255, 221, 253, 0.4)' }) });
    private legalRouteLineCapStyle = new Circle({ radius: 4, fill: new Fill({ color: '#FFA200' }), stroke: new Stroke({ color: 'rgba(197, 197, 197, 0.7)', width: 1 }) });
    private wfsAttributeNames: Array<string> = [];

    // Public variables
    public enabledRouteTracingNodes: Boolean = false;
    public legalRouteStyleCache: Array<IStyleCache> = [];

    // INIT
    public init(config: Array<CoreLayerConfig>) {
        const self = this;

        self.legalRouteStyleCache = [];
        config.forEach(c => {
            if (c.symbologyItem != null) {
                c.symbologyItem.forEach(i => {
                    var s: IStyleCache = { symbologyKey: c.symbologyKey, wfsAttributeName: i.wfsAttributeName, attributeLabel: i.attributeLabel, attributeAltLabel: i.attributeAltLabel, attributeValue: i.attributeValue, showInLegend: i.showInLegend, style: null };
                    var stroke: Stroke = null; var fill = null;
                    if (i.stroke != null) {
                        if (i.stroke.fillColor != null) fill = new Fill({ color: i.stroke.fillColor });
                        stroke = new Stroke({ color: i.stroke.strokeColor, width: i.stroke.width });
                        if (i.stroke.lineDash != null) {
                            var ld = i.stroke.lineDash.split(",");
                            if (ld && ld.length == 2) stroke.setLineDash(ld as any);
                        }
                    }
                    s.style = new Style({ stroke: stroke });
                    if (self.wfsAttributeNames.indexOf(s.wfsAttributeName) == -1) self.wfsAttributeNames.push(s.wfsAttributeName);

                    self.legalRouteStyleCache.push(s);
                });
            }
        });
    }

    public legalRouteStyleFunction = (feature: Feature, resolution, vectorLayer: VectorLayer, self): Style[] => {
        const me:LegalRouteMapStyles = self == null ? this : self.mapStyles.LegalRouteMapStyles; // This is because the function is being called through OpenLayers, so seld refers to MapLayerHelper
        var styles: Array<Style> = [];

        // Search wfsAttributes
        const symbologyKey = vectorLayer.get('symbologyKey');
        var styleCache;
        if (symbologyKey != null) styleCache = me.legalRouteStyleCache.filter(s => s.symbologyKey == symbologyKey);
        else styleCache = me.legalRouteStyleCache;

        // Search wfsAttributes
        me.wfsAttributeNames.forEach(k => {
            var v = feature.get(k);
            if (v != null) {
                // Check to see if the wfsAttribute is mentioned in the style cache
                if (styleCache.find(s => s.wfsAttributeName == k) != null) {
                    // If the wfsAttribute is in the style cache, now check to see if the feature has that value
                    var s = styleCache.find(s => s.wfsAttributeName == k && s.attributeValue == v);
                    if (s != null) styles.push(s.style); // If it does, use the style
                }
            }
        });
        if (styles.length == 0) {
            var s = styleCache.find(f => f.attributeLabel.toLowerCase() == 'default');
            if (s != null) styles.push(s.style);
            if (styles.length == 0) styles.push(me.defaultOverrideLineStyle);
        }

        // Add endpoints
        var c = (feature.getGeometry() as any).flatCoordinates;
        var startStyle = new Style({ geometry: new Point([c[0], c[1]]), image: me.legalRouteLineCapStyle });
        var endStyle = new Style({ geometry: new Point([c[c.length - 2], c[c.length - 1]]), image: me.legalRouteLineCapStyle });
        styles.push(startStyle,endStyle); 

        return styles;
    }
}




